module.exports = __webpack_public_path__ + "static/media/img186.d15abd03.jpg";